import * as commander from 'commander';
import { VHostWorker } from "./entities/VHost";
import container from "./inversify.config";
import TYPES from "./TYPES";
import { ConsoleUI } from "./utils/ConsoleUI";
import { ProviderWorker } from "./entities/Provider";

commander
    .command("list")
    .description("List all the existing CloudProviders")
    .action((cmd, options) => {
        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<ProviderWorker>(TYPES.ProviderWorker);

        worker.list()
       .then(res => {
            ui.loaderSuccess("Ok");
            ui.log(res);
        })
        .catch(err => {
            ui.loaderFail("Error");
            ui.log(err.message);
            process.exit(100);
        });
    });


commander
    .command("create")
    .description("Create a new CloudProvider")
    .action((cmd, options) => {
        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<ProviderWorker>(TYPES.ProviderWorker);

        worker.create()
            .then(res => {
                ui.loaderSuccess("Ok");
                ui.log(res);
            })
            .catch(err => {
                ui.loaderFail("Error");
                ui.log(err.message);
                process.exit(100);
            });
    });
//
//
// commander
//     .command("delete")
//     .option('-n, --hostname <value>', 'vhost hostname')
//     .option('-y, --yes', 'automatically confirm')
//     .description("Deregister an existing VHost")
//     .action(function(cmd, options)  {
//
//         const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
//         const worker = container.get<VHostWorker>(TYPES.VHostWorker);
//
//         let func;
//         if(cmd.yes) {
//             func = worker.deleteVhost(cmd.hostname);
//         }
//         else {
//             func = ui.promptConfirm(`Deleting VHost ${cmd.hostname} (the Cloud Instance will NOT be affected in any way) - Confirm?`).then(confirm => {
//                 if(confirm) {
//                     func = worker.deleteVhost(cmd.hostname);
//                 }
//                 else {
//                     throw Error("User aborted");
//                 }
//             });
//
//         }
//
//         func.then(res => {
//             ui.loaderSuccess("Ok");
//         })
//         .catch(err => {
//             ui.loaderFail("Error");
//             ui.log(err);
//         });
//
//     });
//
//
// function invoke(method: string): void {
//     const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
//
//     ui.loaderStart("Starting....");
//
//     const worker = container.get<VHostWorker>(TYPES.VHostWorker);
//
//     worker[method]()
//         .then(res => {
//             ui.loaderSuccess("Done");
//             ui.log(res);
//         })
//         .catch(err => {
//             ui.loaderFail("Error");
//             ui.log(err);
//         });
//
// }

commander.parse(process.argv);
if (!commander.args.length) commander.help();